"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BENCHMARKING_VARIABLE_NAMES = exports.MARGIN_IMPROVEMENT_VARIABLES = exports.MARGIN_PROFILE_VARIABLES = exports.GROWTH_VARIABLES = exports.SCALE_OF_BUSINESS_VARIABLES = void 0;
const enums_1 = require("../Company/enums");
exports.SCALE_OF_BUSINESS_VARIABLES = [
    enums_1.BenchmarkingVariables.revenueOperatingSms4,
    enums_1.BenchmarkingVariables.ebitdaAdjPreMarketingSms4,
    enums_1.BenchmarkingVariables.ebitdaAdjSms4,
    enums_1.BenchmarkingVariables.assetsCurrentCashAndInvestments,
    enums_1.BenchmarkingVariables.assetsCurrentInvty,
    enums_1.BenchmarkingVariables.assetsCurrentRcv,
    enums_1.BenchmarkingVariables.assetsNonCurrentNetPropPlantEquipment,
];
exports.GROWTH_VARIABLES = [
    enums_1.BenchmarkingVariables.revenueOperatingSms4Ret4,
    enums_1.BenchmarkingVariables.ebitdaAdjPreMarketingSms4Ret4,
    enums_1.BenchmarkingVariables.ebitdaAdjSms4Ret4,
    enums_1.BenchmarkingVariables.assetsCurrentCashAndInvestmentsRet4,
    enums_1.BenchmarkingVariables.assetsCurrentInvtyRet4,
    enums_1.BenchmarkingVariables.assetsCurrentRcvRet4,
    enums_1.BenchmarkingVariables.assetsNonCurrentNetPropPlantEquipmentRet4,
];
exports.MARGIN_PROFILE_VARIABLES = [
    enums_1.BenchmarkingVariables.grossProfitAdjSms4DivRevenueOperatingSms4,
    enums_1.BenchmarkingVariables.ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4,
    enums_1.BenchmarkingVariables.salesMarketingSms4DivRevenueOperatingSms4,
];
exports.MARGIN_IMPROVEMENT_VARIABLES = [
    enums_1.BenchmarkingVariables.grossProfitAdjSms4DivRevenueOperatingSms4Ret4,
    enums_1.BenchmarkingVariables.ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4Ret4,
    enums_1.BenchmarkingVariables.salesMarketingSms4DivRevenueOperatingSms4Ret4,
];
exports.BENCHMARKING_VARIABLE_NAMES = Object.entries(enums_1.BenchmarkingVariables).reduce((names, [key, value]) => (Object.assign(Object.assign({}, names), { [value]: key })), {});
//# sourceMappingURL=IndustryBenchmarks.js.map